export interface QuestionInterface {
  // General
  id: string | number; //id
  isEnact?: boolean;
  type: string; //range, true-false, test, long-answer, info, multiple, conditional, interactiveGrid, representatives, flipGrid
  title?: string; //main title of question content
  questionTitle?: string; //question title itself
  description?: string; //question main description text
  details?: any[]; //question details. Array of objects. Object types:
  offBold?: boolean; //to remove bold from questionSubtitle
  allCorrect?: boolean; //if all multiple choice can be slected
  isRanking?: boolean; //if multiple choice is ranking
  isEntrust?: boolean;  //use to display Attorney  instead of Representative in Guide to Entrust
  // Delimiter: {type: "delimiter"}
  // Paragraph: {type: "paragraph", value: "Some value"}
  // Heading2: {type: "heading2", value: "Some value"}
  // Heading3: {type: "heading3", value: "Some value"}
  // Heading4: {type: "heading4", value: "Some value"}
  // Image: {type: "image", value: "image-name.png" alt="some data"}
  // Video: {type: "video", title: "Video title" embedUrl="TbyV6Z_WQJQ"}
  // Links: {type: "links", items: [{url: "/link", value: "Link Text"}]}
  // List: {type: "list", items: ["item1", "item2", "item3"]}
  // ListNumeric: {type: "listNumeric", items: ["item1", "item2", "item3"]}
  // ListLinks: {type: "listLinks", items: [{content: "link to learning center", linkUrl: "/link", title: "Medical Care"}]}
  // ListImages: {type: "listImages", items: [{img: "image-name.png", title: "Title"}]}
  // DecisionsImageSlider: {type: "decisions-image-slider"}
  // ImageAddition: {type: "image-addition"}
  // Slider: {type: "slider", slides: [{title: "Title", text: "Text", type: "card"}]}
  image?: string; //question image on right side
  answersResponse?: any[]; //response on answered. Array of objects. Object types:
  // Delimiter: {type: "delimiter"}
  // Paragraph: {type: "paragraph", value: "Some value"}
  // Heading1: {type: "heading1", value: "Some value"}
  // Heading2: {type: "heading2", value: "Some value"}
  // Heading3: {type: "heading3", value: "Some value"}
  // Heading4: {type: "heading4", value: "Some value"}
  // Image: {type: "image", value: "image-name.png" alt="some data"}
  // Card: {type: "card", data: {title: "Title", image: "image-name.png", text: "text"}}
  // Message: {type: "message", data: {title: "Title", imageRight: true, image: "image-name.png", text: "text"}}
  // Columns: {type: "message", columnsData: [{type: "right|left", tagTitle: "h2|h3", title: "Title", image: "image-name.png", text: "text"}]}
  // Video: {type: "video", title: "Video title" embedUrl="TbyV6Z_WQJQ"}
  // Links: {type: "links", items: [{url: "/link", value: "Link Text"}]}
  // List: {type: "list", items: ["item1", "item2", "item3"]}
  // ListNumeric: {type: "listNumeric", items: ["item1", "item2", "item3"]}
  // ListLinks: {type: "listLinks", items: [{content: "link to learning center", linkUrl: "/link", title: "Medical Care"}]}
  // ListImages: {type: "listImages", items: [{img: "image-name.png", title: "Title"}]}
  // DecisionsImageSlider: {type: "decisions-image-slider"}
  // ImageAddition: {type: "image-addition"}
  // Slider: {type: "slider", slides: [{title: "Title", text: "Text", type: "card"}]}
  // Also you can add a question here
  offDelimiter?: boolean; //set true if you want to disable delimiter
  eduContent?: object[]; //Educational Content. Supports exactly the same data as answersResponse
  eduContentTitle?: string; //Educational Content Accordion Title
  moreInfoTitle?: string;
  moreInfoContent?: object[];
  eduContentDefaultView?: boolean; //Set true if educational content accordion should be open by default
  noValidation?: boolean; //set true if question does not require any validation
  video?: {
    embedUrl: string;
    title: string;
  }; //video in question description

  // Range type specific
  max?: number; //Max range button
  min?: number; //Min range button
  afterMinLabel?: number; //before Min range button label
  beforeMaxLabel?: number; //before Max range button label
  maxLabel?: string; //Max range button label
  minLabel?: string; //Min range button label
  equalLabel?: string; //Range button label on the middle
  titleClass?: boolean; //set true if question title has to be smaller
  quantity?: string; //quantity label on top
  quality?: string; //quality label on top

  // True/False specific
  correctAnswer?: boolean; //correct value
  incorrectAnswer?: boolean; //incorrect value
  onFalseResponse?: any[]; //Answer response only when user choose "false". Supports exactly the same data as answersResponse
  onTrueResponse?: any[]; //Answer response only when user choose "true". Supports exactly the same data as answersResponse
  yesNoMode?: boolean; //set true if you want yes/no instead if true/false
  allowIncorrect?: boolean; //set true if you want to allow user proceed with incorrect answer
  shareDocument?: { doc: string; guide: string }; //used for sharing documents (example {guide: 'equip', doc: 'personal_directive_letter'})
  customTrueLabel?: string; //custom button text instead of default "True"
  customFalseLabel?: string; //custom button text instead of default "False"
  blockIfIncorrect?: boolean; //set true if you want user to be blocked if answer is incorrect

  // Test type specific
  options?: {
    correct: boolean;
    text: string;
    blocker?: boolean;
    disabled?: boolean;
    title?: string;
    img?: string;
  }[]; //test answer options
  onCorrectAnswer?: { title: string; text: string }; //response when user responded correctly
  onInCorrectAnswer?: { title: string; text: string }; //response when user responded incorrectly
  testNumber?: boolean; //set true if you want question to be numbered intead of a,b,c
  withBlocker?: boolean; //set true if question includes option which can potentially block user processing
  editable?: boolean; //set true if you want to let user change his/her answer
  select?: boolean; //set true if you want display question as a select instead of radio buttons
  defaultSelectValue?: boolean; //set true if first option should be chosen by default
  numberedOptions?: boolean; //set true if you want options to be numbered
  multipleChoice?: boolean; //set true if you want to allow user to choose more than 1 option
  valuesToExpect?: number; //set how many options to expect to process, ignore if only 1
  answerResponseModal?: object[]; //modal data when user's answer is correct
  answerResponseModalIncorrect?: any; //modal data when user's answer is incorrect
  shouldWaitForAnswers?: boolean; //hide until prev question is not answered(used in Grid)

  // Conditional type specific
  variants?: QuestionInterface[]; //question variants
  conditions?: { condition: number[]; nextQuestion: string | number }[]; //array, for example if you want to show question 7a if user has 0-3 correct answers and 7b when 4 correct answers you should do something like this: conditions: [{condition: [4], nextQuestion: "7a"}, {condition: [0, 1, 2, 3], nextQuestion: "7b"}]
  currentVariant?: string | number; //set default id here

  // Multiple type specific
  questions?: QuestionInterface[]; //questions array
  parentId?: string | number; //id of the highest level
  nextQuestionId?: string | number; //if you have multiple test questions and next one is conditional, set the parent id of next question here

  // Representatives type specific
  simplified?: boolean; //set true if you expect only one representative

  // Grid type specific
  grid?: {
    answer1: number | string; //id of first selector
    answer2: number | string; //id of second selector
    id: number | string; //id of grid
    parentId: number | string; //id of parent multiple type question
  };
  gridtitle?: string; //title above grid
  answer1?: string | number; //id of first selector
  answer2?: string | number; //id of first selector
  preferenceItems?: {
    active?: string;
    activeOne?: string;
    activeSecond?: string;
    description: string;
    letter: string;
    subtitle: string;
    title: string;
  }[]; //array. Example: {active: "full_icu_cpr", description: "Description", letter: "A", subtitle: "Live At All Costs", title: "Full ICU Care + CPR"}

  // Info Type Specific
  modalState?: boolean;
  iconMode?: string; //success/warning

  //Long Answer
  body?: any[]; //Array of objects. Object types:
  // Delimiter: {type: "delimiter"}
  // Paragraph: {type: "paragraph", value: "Some value"}
  // Heading2: {type: "heading2", value: "Some value"}
  // Heading3: {type: "heading3", value: "Some value"}
  // Link: {type: "link", url: "/link", text: "Label"}
  // Textarea: {type: "textarea", placeholder: "Placeholder"}

  // General helpers
  conditionalContent?: boolean; //set true if you display some response content conditionally
  subDescription?: any[]; //array of question details objects
  modalAllDisabled?: boolean; //disable modal(Range and True/False)
  pleaseContinueModal?: boolean; //set true if modal is please continue mode (Range and True/False)
  conditionalContentModal?: boolean; //set true if you display some modal response content conditionally
  questionSubTitle?: string; //additional subtitle (for range and test)
}

export const DEFAULT_GUIDES_QUESTIONS: { data: QuestionInterface[] } = {
  data: [
    {
      conditionalContent: true,
      description:
        "If you (or the person you are helping to fill out this plan) are a resident of a long-term care home, Plan Well Guide is still appropriate to use to help clarify your values and develop goals of care. However, there is one additional consideration to think about when developing a future medical plan for yourself or your loved one. You need to think about the best location to receive future medical care when you are seriously ill.",
      iconMode: "success",
      id: 10,
      image: "public-new/question-image-second.png",
      yesNoMode: true,
      onFalseResponse: [
        { type: "delimiter" },
        {
          image: "public-new/great.svg",
          text: "Let’s proceed with finalizing your plan!",
          title: "If no, please continue!",
          type: "card",
        },
      ],
      onTrueResponse: [
        { type: "delimiter" },
        {
          type: "heading2",
          value:
            "If yes, consider reading about whether you (or your loved one) would want to be transferred to an acute care hospital to receive additional care.",
        },
        { type: "heading3", value: "Learning Center Links" },
        {
          items: [
            { content: " [https://]", linkUrl: "#", title: "Long Term Care" },
          ],
          type: "listLinks",
        },
      ],
      questionTitle:
        "Are you a resident of long-term care or helping a person who is in long-term care?",
      title: "Resident of a Long-Term Care setting?",
      type: "true-false",
    },
    {
      answersResponse: [
        { type: "delimiter" },
        {
          type: "paragraph",
          value:
            "Now that we have provided you with a solid understanding of the various treatment options when seriously ill, we can finalize the process of determining the medical care that is right for you.",
        },
      ],
      description:
        "Now we are going to combine all the information we have discussed with you about ICU, CPR, Medical, and Comfort care into the specific range of medical treatments available to treat serious illnesses and the types of people that typically choose those treatments. We think it will be helpful to review this table before beginning to make your plan.",
      details: [
        {
          type: "paragraph",
          value:
            "At the end of this step, we will ask you to pick your preferences for the medical treatments available to treat serious illnesses.",
        },
        {
          alt: "Let’s Summarize",
          type: "image",
          value: "public-new/asip_summarize.png",
        },
        { type: "heading3", value: "A - Live At All Costs" },
        {
          type: "paragraph",
          value:
            "Use machines and all possible measures including admission to ICU and resuscitation (CPR) with a focus on keeping me alive at all costs. Usually a younger person, but can also involve an older person with no or limited health problems. People are willing to undergo prolonged critical illness with hopes of survival even if they suffer a reduction in their function or quality of life. Not for people with significant health problems, those who wouldn’t want to endure a prolonged critical illness, or those who would not want any further reduction in their quality of life.",
        },
        { type: "heading3", value: "B - Go For It" },
        {
          type: "paragraph",
          value:
            "Use machines and all possible measures including admission to ICU with a focus on keeping me alive. If my heart stops, no resuscitation (CPR). Similar to “Live At All Costs” but for people who would rather die than receive CPR and risk the consequence of living with some degree of brain injury from it.",
        },
        { type: "heading3", value: "C - Give Me A Chance" },
        {
          type: "paragraph",
          value:
            "Use machines and all possible measures including admission to ICU and CPR but only in the short term to see if I will get better. If the illness is prolonged, change focus to comfort measures only and if my heart stops, no further resuscitation (CPR). Usually, a person in reasonable health or with only mild-moderate health problems. They want a chance to recover from serious illness but are not willing to put up with the downside of prolonged critical illness. They understand that they can possibly survive prolonged critical illness but enduring it only to survive in a reduced health state is not worth it to them.",
        },
        { type: "heading3", value: "D - Try For A Bit" },
        {
          type: "paragraph",
          value:
            "Use machines and all possible measures including admission to ICU (but no CPR) only in the short term to see if I will get better. If my illness is prolonged, change focus to comfort measures only. If my heart stops, no resuscitation (CPR).Similar to “Give Me A Chance” but they too are more worried about the consequences of CPR and being alive with a brain injury than they would be with dying.",
        },
        { type: "heading3", value: "E- Easy Does It" },
        {
          type: "paragraph",
          value:
            "Use full medical care to prolong my life. If my heart or my breathing stops, no resuscitation (CPR) or breathing machines Usually, an older person or someone who is living with significant medical problems just want conservative treatments, such as antibiotics, blood thinners, or other intravenous medications. They don’t want to go to ICU but are open to other less invasive treatments to cure them. They accept that death may be inevitable if these conservative treatments don’t work.",
        },
        { type: "heading3", value: "F – I Am Ready To Go" },
        {
          type: "paragraph",
          value:
            "Use comfort measures only with a focus on improving the comfort and the quality of my remaining days. In other words, allow a natural death, no artificial prolongation of life and no resuscitation (CPR). Usually an older person or people with advanced medical problems or terminal diseases that are not interested in any further ‘curative’ attempts. They are ‘ready to die’ when the next serious complication arises and request that all treatments focus on comfort measures only. They understand that curative treatments may be withheld and thus, they will forgo opportunities to recover from their serious illness in favor of a peaceful, comfortable death.",
        },
        {
          type: "heading3",
          value: "Need to review the types of care again?",
        },
        { type: "heading3", value: "Learning Center Links" },
        {
          items: [
            {
              content: "link to learning center",
              linkUrl: "#",
              title: "ICU Care",
            },
            {
              content: "link to learning center",
              linkUrl: "#",
              title: "Medical Care",
            },
            {
              content: "link to learning center",
              linkUrl: "#",
              title: "Comfort Care",
            },
          ],
          type: "listLinks",
        },
      ],
      id: 11,
      image: "public-new/question-image-first.png",
      questions: [
        {
          id: "11a",
          offDelimiter: true,
          options: [
            { correct: true, text: "Live At All Costs" },
            { correct: true, text: "Go for It" },
            { correct: true, text: "Give Me A Chance" },
            { correct: true, text: "Try For A Bit" },
            { correct: true, text: "Easy Does It" },
            { correct: true, text: "I Am Ready To Go" },
          ],
          questionTitle:
            "There is more information coming but based on the information we have provided so far, which treatment option do you think would suit you the best at this time?",
          type: "test",
        },
      ],
      title: "Let’s Summarize",
      type: "multiple",
    },
    {
      answersResponse: [
        {
          body: [
            { type: "delimiter" },
            {
              type: "heading4",
              value:
                "If you would like more information that might help reduce your anxiety and make you more ready to finalize your preferences, check out our additional content below",
            },
          ],
          breakpoint: 8,
        },
        {
          body: [
            { type: "delimiter" },
            {
              image: "public-new/great.svg",
              text: "Let’s proceed with finalizing your plan!",
              title: "Great.",
              type: "card",
            },
          ],
          breakpoint: 10,
        },
      ],
      conditionalContent: true,
      description:
        "In the next section, we will ask you some questions to help you finalize your serious illness plans in case you were to get seriously ill today (not some distant time point in the future). Many people get anxious and afraid to ‘commit’ to answers to the questions we will ask them. Some want a chance at recovery and yet are worried that they may make a mistake asking for ICU care and end up stuck on machines forever. Realize your answers today are not permanent, they can be changed and updated as you age and your health changes. If you have questions for your doctor, there will be a place to document them at the end of the planning process.",
      eduContent: [
        { type: "delimiter" },
        {
          type: "heading2",
          value: "Call out box of dialogue between doctor and patient",
        },
        { type: "heading4", value: "Patient:" },
        {
          type: "paragraph",
          value:
            "Maintaining my quality of life (at the expense of the quantity of my life) is most important to me. But if I were to get seriously ill today, I would want a chance at recovery and would want to go to ICU. But I am worried that 3 months later, I would still be bedridden and on a ventilator and I wouldn’t want that! I don’t want to go through a prolonged illness only to end up in worse condition than I already am.",
        },
        { type: "heading4", value: "Doctor:" },
        {
          type: "paragraph",
          value:
            "Don’t worry. Your substitute decision-maker in working with your doctor can always change your goals of care and have the life-sustaining treatments removed. They can change the focus of your care to comfort measures if it looks like you won’t recover quickly from your serious illness or that you might end up in a  state of health worse than death. Perhaps a short-term trial of ICU care may be right for you?",
        },
        { type: "delimiter" },
        {
          type: "paragraph",
          value:
            "Note: It will be helpful to your representative and doctor if you record this fear, discuss it with them, and define, in your words, what you mean by ‘short-term.’ Short-term trial of ICU care is one of the treatment options in this planning guide. Later in the plan you will be given the opportunity to define health states worse than death or what health conditions are unacceptable to you.",
        },
      ],
      id: 12,
      image: "public-new/question-image-second.png",
      max: 10,
      maxLabel: "Absolutely ready to proceed",
      min: 1,
      minLabel: "Not ready at all",
      questionTitle:
        "How ready are you to proceed to finalizing your preferences for medical treatment when you are seriously ill?",
      title: "Anxious about finalizing your plan?",
      type: "range",
    },
    {
      description:
        "Now that you better understand the differences between the different types of care offered when someone is seriously ill, let’s ask you more questions that will help you determine what medical treatments are right for you.",
      details: [
        {
          type: "paragraph",
          value:
            "Remember, you are not making a final medical decision today. You are preparing yourself (and your substitute decision-maker) to express your values and preferences should you become seriously ill.  Your answers to these value questions and medical treatment preferences  will be incorporated with your doctor’s assessment of your future serious illness problem to help make a final decision that reflects your wishes.",
        },
        { type: "image", value: "public-new/asip_ready_finalize.jpeg" },
        {
          type: "heading3",
          value:
            "Suppose today you got hit by a bus and were seriously ill. Given your current life circumstances, please answer the following questions",
        },
        {
          type: "paragraph",
          value:
            "As illustrated by the grid, there is a relationship between the answers to the values questions and the medical treatments in each of the squares. In each of these squares above are statements of different treatment options.",
        },
        {
          type: "paragraph",
          value:
            " If you land on the grid in a square that suggests a medical treatment that does not match what you think is right for you, you will need to go back to the values questions and review and possibly change your answers.",
        },
        { type: "valuesSection" },
      ],
      id: 13,
      image: "public-new/question-image-first.png",
      questions: [
        {
          id: "13a",
          offDelimiter: true,
          options: [
            { correct: true, text: "1 = Very Willing" },
            { correct: true, text: "2 = Moderately willing" },
            { correct: true, text: "3 = Slightly willing" },
            { correct: true, text: "4 = Neutral" },
            { correct: true, text: "5 = Slightly unwilling" },
            { correct: true, text: "6 = Moderately unwilling" },
            { correct: true, text: "7 = Not Willing at all" },
          ],
          questionTitle:
            "Risks of ICU Treatments: On a scale of 1-7, select the number to best describe how willing you are to accept the risks of ICU treatments/resuscitation:",
          testNumber: true,
          type: "test",
        },
        {
          id: "13b",
          offDelimiter: true,
          options: [
            { correct: true, text: "1 = Very Willing" },
            { correct: true, text: "2 = Moderately willing" },
            { correct: true, text: "3 = Slightly willing" },
            { correct: true, text: "4 = Neutral" },
            { correct: true, text: "5 = Slightly unwilling" },
            { correct: true, text: "6 = Moderately unwilling" },
            { correct: true, text: "7 = Not Willing at all" },
          ],
          questionTitle:
            "Reduction in Function or Quality of life:  On a scale of 1-7, select the number to describe how willing you are to accept a significant reduction in your ability to look after yourself or a significantly lower quality of life following recovery from an ICU stay than you currently experience:",
          testNumber: true,
          type: "test",
        },
        {
          answersResponse: [
            {
              body: [
                {
                  type: "heading3",
                  value: "Please tell us why you are unsure in the space below",
                },
                { type: "textarea" },
                {
                  type: "paragraph",
                  value:
                    "Please be reassured that you are not making a final decision today. You can discuss your preference with your doctor and come back and update this plan. And know that you will be discussing your final preference with a doctor in the future, before making a final decision, to be sure that you preference is right for you given the nature of your serious illness.",
                },
              ],
              condition: "Unsure",
              id: "13d",
              parentId: 13,
              questionTitle:
                "Please tell us why you are unsure in the space below.",
              type: "long-answer",
            },
          ],
          id: "13e",
          offDelimiter: true,
          options: [
            { correct: true, text: "Yes" },
            { correct: true, text: "No" },
            { correct: true, text: "Unsure" },
          ],
          questionTitle:
            "At this point, does the box highlighted above best represent your preference?",
          type: "test",
        },
        {
          body: [
            { type: "heading3", value: "I chose this preference because" },
            { type: "textarea" },
          ],
          id: "15f",
          offDelimiter: true,
          questionTitle: "I chose this preference because",
          type: "long-answer",
        },
        {
          answersResponse: [
            { body: [], breakpoint: 6 },
            { body: [""], breakpoint: "10" },
          ],
          id: "14g",
          max: 7,
          maxLabel: "Extremely Confident",
          min: 1,
          minLabel: "Not at all Confident",
          questionTitle:
            "On a Scale of 1 - 7, how SURE do you feel that your selected option is the best choice for you?",
          titleClass: true,
          type: "range",
        },
      ],
      title: "Is Going to the ICU Right for You? ",
      type: "multiple",
    },
    {
      answersResponse: [
        {
          body: [
            { type: "delimiter" },
            {
              type: "heading2",
              value:
                "Looks like you could use some help picking and preparing your legal representative. We can help!",
            },
            {
              type: "paragraph",
              value:
                "Let’s begin by giving you a clear picture of what we are preparing you and your legal representative for.",
            },
            {
              type: "paragraph",
              value:
                "Consider watching this 3 minute video to get a real picture of what this decision-making encounter looks like:",
            },
            {
              type: "paragraph",
              value:
                "{What VR video. Give instructions on how to watch in 3D if have headset}",
            },
          ],
          breakpoint: 8,
        },
        {
          body: [
            { type: "delimiter" },
            { type: "heading2", value: "That’s great." },
            {
              type: "paragraph",
              value:
                "Then you are in ‘good shape’ and can have the peace of mind that someone can represent your authentic values and informed treatment preferences for your personal and medical care. In addition, you can feel good that someone knows how to best manage your finances if you were unable and you’ve put the proper controls in place to avoid abuse or misuse of funds. One thing to consider though is that as much as you ‘think’ you prepared your legal representative, how sure can you be if you’ve never really experienced serious illness? Think about it. How sure are you that they won’t be super stressed fulfilling their role as your legal representative? Will they know exactly how to make all those decisions on your behalf? Consider watching this 3 minute video to get a real picture of what this decision-making encounter looks like:",
            },
            {
              type: "paragraph",
              value:
                "{What VR video. Give instructions on how to watch in 3D if have headset}",
            },
          ],
          breakpoint: 10,
        },
      ],
      conditionalContent: true,
      description:
        "Have you ever had the responsibility to order off a menu a meal for a partner or friend and felt the stress of wondering ‘if you got it right?”  Imagine if you had the responsibility of ‘picking your friend’s wedding dress for her’ without getting any input from her - just basing your decisions on how well you know her. Would you find these scenarios stressful?",
      details: [
        {
          type: "paragraph",
          value:
            "Recognize that If you are incapacitated due to serious illness or injury, you will need someone to work with other professionals on your behalf to:",
        },
        {
          items: [
            "make life and death medical decisions",
            "make important personal care decisions",
            "manage your finances and make important financial decisions for you.",
          ],
          type: "listNumeric",
        },
      ],
      eduContent: [
        { type: "delimiter" },
        {
          type: "paragraph",
          value:
            "To get an in-depth understanding of how to select and equip a representative, continue into Guide 2: Entrusting Your Values and Preferences to a Representative.",
        },
      ],
      id: 16,
      image: "public-new/question-image-first.png",
      max: 10,
      maxLabel: "Extremely confident",
      min: 1,
      minLabel: "Not very confident at all",
      questionTitle:
        "How confident are you that your legal representative can make the right decisions for your personal, medical and financial care if you were unable to manage for yourself?",
      title: "Who will speak for you when you can’t?",
      type: "range",
    },
    {
      description:
        "As you think about the future, it is helpful to your future doctors and your appointed representative  decision-maker  to know if there are conditions or health states that you feel are ‘worse than death.’ For example, some people feel that being in a long-term coma, being bed-ridden in an institution dependent on others or being alive but not able to recognize family are such conditions.",
      id: 15,
      image: "public-new/question-image-fourth.png",
      questions: [
        {
          body: [
            {
              type: "heading2",
              value:
                "Please describe possible future health states that you would consider to be unacceptable.",
            },
            { type: "textarea" },
            { type: "delimiter" },
          ],
          id: "15a",
          offDelimiter: true,
          questionTitle:
            "Please describe possible future health states that you would consider to be unacceptable.",
          type: "long-answer",
        },
        {
          body: [
            {
              type: "paragraph",
              value:
                "You may still have some questions about the different types of medical care. Or maybe you want to record additional considerations such as desired religious rituals or feelings about medical assistance in dying (MAID). You might also have some concerns or fears that you want to discuss with your doctor.",
            },
            {
              type: "heading3",
              value:
                "Write these questions, considerations, or concerns down so that you remember to discuss them later with your doctor:",
            },
            { type: "textarea" },
            {
              type: "paragraph",
              value:
                "Remember, you can update or change your plan at any time. Just log back into Plan Well Guide and make the appropriate changes as your life circumstances or health change.",
            },
          ],
          id: "15b",
          offDelimiter: true,
          questionTitle:
            "Write these questions, considerations, or concerns down so that you remember to discuss them later with your doctor:",
          type: "long-answer",
        },
      ],
      title: "Health Conditions Worse Than Death",
      type: "multiple",
    },
    {
      answerResponseModal: [
        { type: "heading3", value: "Correct!" },
        {
          type: "paragraph",
          value:
            "At the point when you experience a serious illness, doctors will need to know whether to apply life-sustaining treatments and they may not know for sure if you are dying, so end of life plans don’t apply. The goal of this workbook is to help you explore, identify and communicate your authentic values and informed treatment preferences for medical care during a serious illness so that you get the medical care that is right for you - whether you live or die .",
        },
        {
          type: "paragraph",
          value:
            "Since you answered this correctly, feel free to continue to the next section.",
        },
      ],
      answerResponseModalIncorrect: [
        { type: "heading3", value: "The correct answer is “False”" },
        {
          type: "paragraph",
          value:
            "At the point when you experience a serious illness, doctors will need to know whether to apply life-sustaining treatments and they may not know for sure if you are dying, so end of life plans don’t apply. The goal of this workbook is to help you explore, identify and communicate your authentic values and informed treatment preferences for medical care during a serious illness so that you get the medical care that is right for you - whether you live or die .",
        },
        {
          type: "paragraph",
          value: "Consider reviewing the additional information provided.",
        },
      ],
      conditionalContent: false,
      correctAnswer: false,
      description:
        "Serious illness is the kind of medical condition that requires you to be in the hospital, like a bad COVID-19 pneumonia, an injury from a serious motor vehicle accident, or a major heart attack or stroke. With serious illness there is both a chance of death and a chance of recovery.",
      details: [],
      eduContent: [
        { type: "delimiter" },
        {
          type: "heading2",
          value: "This is not end of life planning. You may…",
        },
        {
          items: [
            "Have already thought and talked about your wishes for terminal care at the end of your life or,",
            " Feel that advance care planning is not important right now because you are not sick or close to the end of your life.",
          ],
          type: "list",
        },
        {
          type: "heading3",
          value:
            "This is NOT that. Serious Illness Planning is something different.",
        },
        { type: "decisions-image-slider" },
      ],
      iconMode: "success",
      id: 1,
      image: "public-new/question-image-second.png",
      onFalseResponse: [
        { type: "delimiter" },
        {
          type: "heading2",
          value: "This is not end of life planning. You may…",
        },
        {
          items: [
            "Have already thought and talked about your wishes for terminal care at the end of your life or,",
            "Feel that advance care planning is not important right now because you are not sick or close to the end of your life.",
          ],
          type: "list",
        },
        { type: "heading3", value: "This is not that. This is different." },
      ],
      onTrueResponse: [
        { type: "delimiter" },
        {
          type: "heading2",
          value: "This is not end of life planning. You may…",
        },
      ],
      questionTitle:
        "Today, on Plan Well Guide, you are making a plan for the type of medical care you want to receive when you are dying.",
      title: "What is serious illness?11",
      type: "true-false",
    },
    {
      answersResponse: [
        {
          body: [
            { type: "delimiter" },
            {
              type: "paragraph",
              value:
                "We observe that about ¼ of people who start our planning process don’t finish. People who have strong internal motivations are much more likely to hang in there when things get difficult. So we’d like to suggest a few exercises to help you find your motivations that will carry you through the finish line (see below).",
            },
            { type: "delimiter" },
          ],
          breakpoint: 6,
        },
        {
          body: [
            { type: "delimiter" },
            {
              image: "public-new/great.svg",
              text: "You are highly motivated and are likely to have a successful experience finishing your ASIP.  Carry on your journey by clicking “Next Step” below.",
              title: "That’s great!",
              type: "card",
            },
            { type: "delimiter" },
          ],
          breakpoint: 10,
        },
      ],
      conditionalContent: true,
      description:
        "With advance serious illness planning, we are not making medical decisions today. We are preparing you today for future decisions should you become seriously ill. We do not know when serious illness might strike, it could be tomorrow or it could be 30 years from now. At that point, a doctor will try to speak to you and explain what is going on and how they might treat you. It may be your family doctor or more likely it will be an Emergency Room (ER) or Intensive Care Unit (ICU) doctor that you’ve never met before.",
      details: [
        {
          type: "paragraph",
          value:
            "They will want to know your values and medical treatment preferences to help them make the decision that’s right for you.",
        },
        {
          type: "heading4",
          value: "People who engage in advance serious illness planning:",
        },
        {
          items: [
            "Report a greater sense of control over their health care,",
            "Report improved communication between them, their family members and their clinicians, and",
            "Report increased satisfaction with their medical care they receive.",
            "Were much more likely to get medical care, that was right for them (consistent with their values and preferences).",
          ],
          type: "list",
        },
        {
          type: "paragraph",
          value:
            "Also, advance serious illness planning has been shown to reduce the burden and conflict among loved ones and reduce stress, anxiety, and depression in surviving family members.",
        },
        { type: "heading4", value: "OUR GOAL" },
        {
          type: "paragraph",
          value:
            "To help you prepare a plan that clearly communicates your value statements and medical treatment preferences that you can share with your doctor and your loved ones, particularly those you ask to represent you if you were not able to do so yourself.",
        },
      ],
      eduContent: [
        {
          type: "paragraph",
          value:
            "Need help finding your “why”? Why should you spend time on  this activity? First, our attitudes and beliefs are key determinants to our behaviors. What attitudes and beliefs do you currently have that are holding you back from moving forward with zeal and zest to finish your serious illness planning?",
        },
        {
          type: "heading3",
          value:
            "Consider the results of our research that shows what other people think and our response:",
        },
        {
          slides: [
            {
              text: "You don’t have to be sick to plan for future serious illness. Serious illness can strike at any time. The best time to do serious illness planning is when you are well.",
              title: "“I am not sick enough. I am healthy right now.”",
              type: "card",
            },
            {
              text: "“We understand your angst to confront your own mortality. But we are not doing end of life planning. This is planning for serious illness, for future periods of incapacitation due to illness or injury.",
              title: "“I don’t want to think about death and dying.”",
              type: "card",
            },
            {
              text: "Yes, it is. If you don’t do it, you are more likely to get the ‘wrong’ medical care when you get seriously ill and your family member who has to make life and death decisions on your behalf will be very stressed by this burden. This suffering can be alleviated by some upfront planning.",
              title: "“Advance serious illness planning is not important.”",
              type: "card",
            },
            {
              text: "Doctors believe it is important and are equally frustrated with the situation. They say their biggest barrier to talking to their patients is their belief that the patient and/or family don’t want to talk about this or aren’t ready or prepared for the discussion. You can make it easier on your doctor by going through the planning process and presenting them with a copy of your ‘Dear Doctor’ letter. They will love you for doing that!",
              title:
                "“If it were important, why doesn’t the doctor bring it up.”",
              type: "card",
            },
            {
              text: "Your family may know you well. But they don’t know you well enough to know exactly what to do then called upon to make life and death decisions on your behalf. Consequently, they will experience significant stress and anxiety if you don’t know your values and preferences. Give them a copy of your ‘Dear Doctor’ letter and they will thank you for it.",
              title: "“My family knows me. They will do right by me.”",
              type: "card",
            },
            {
              text: "Current audits of decision-making in hospitals show a medical error rate of 66%. That’s a ⅓ chance of getting it right if you rely on the system to ‘guess’ what’s right for you.",
              title:
                "“I trust my doctor and the health care system. They will do right by me.”",
              type: "card",
            },
            {
              text: "How sensible is it that you do your health planning with a lawyer? We are trying to change legal practice and get them out of the health planning business. Their health planning practices are not helpful to you or us, your future doctors.",
              title:
                "“I’ve already done this. I’ve been to my lawyer and signed the papers.”",
              type: "card",
            },
          ],
          type: "slider",
        },
        {
          type: "heading4",
          value:
            "We hope you have discovered your ‘why’ serious illness planning in advance is important and are ready to proceed!",
        },
      ],
      id: 2,
      image: "public-new/question-image-first.png",
      max: 10,
      maxLabel: "Absolutely committed to finishing my ASIP!",
      min: 0,
      minLabel: "Very little motivation",
      questionTitle:
        "How motivated are you to complete your advance serious illness plan?",
      title: "Advance Serious Illness Planning",
      type: "range",
    },
    {
      answerResponseModal: [
        { type: "heading3", value: "False." },
        {
          type: "paragraph",
          value:
            "You are not making medical decisions today. You are preparing yourself  for future decision-making with a doctor when you are seriously ill. Unfortunately, at that time, most people are unable to think clearly or speak, so they need to appoint and educate someone to represent them when they become unable. The doctor will obtain ‘informed consent’ from you or your appointed representative at that point. When that future moment arrives and you are seriously ill, you should be prepared to ask lots of questions, to be sure you understand the final medical decision made, because the consequences will have life and death implications. Next are examples of questions that you may want to ask the doctor, when seriously ill, to be sure you are getting the medical care that is right for you. Check them out if you are interested.",
        },
      ],
      answerResponseModalIncorrect: [
        { type: "heading3", value: "True." },
        {
          type: "paragraph",
          value:
            "You are not making medical decisions today. You are preparing yourself for future decision-making with a doctor when you are seriously ill. Unfortunately, at that time, most people are unable to think clearly or speak, so they need to appoint and educate someone to represent them when they become unable. The doctor will obtain ‘informed consent’ from you or your appointed representative at that point. When that future moment arrives and you are seriously ill, you should be prepared to ask lots of questions, to be sure you understand the final medical decision made, because the consequences will have life and death implications. Next are examples of questions that you may want to ask the doctor, when seriously ill, to be sure you are getting the medical care that is right for you. Check them out if you are interested.",
        },
      ],
      conditionalContent: false,
      correctAnswer: false,
      description:
        "Our goal with this module is to help you find and be able to communicate your values and preferences in a way that you receive the medical care that is right for you when you are seriously ill. Realize that like many things in life, we don’t always get exactly what we may want or wish for.",
      details: [
        {
          type: "paragraph",
          value:
            "This principle applies to serious illness planning because the decisions about which medical treatments you receive depend on a variety of factors including your values and preferences. However, these values and preferences need to be put in context of your illness and you will discuss and make the final decision with the doctor when you are ill. This process of making ‘shared’ medical decisions is illustrated in the figure:",
        },
        {
          alt: "Making medical decisions with doctors",
          type: "image",
          value: "public-new/asip_shered_medical.png",
        },
        { type: "heading3", value: "Values and preferences:" },
        {
          type: "paragraph",
          value:
            "What sets Plan Well Guide apart is that we help you determine and communicate your value statements and informed medical treatment preferences in a way that increases the chances of getting the medical treatments that are right for you.",
        },
        { type: "heading3", value: "Medical Problem:" },
        {
          type: "paragraph",
          value:
            "Your values and preferences have to be put in context with the medical problem you have. That medical problem could be a major heart attack, severe stroke, or bad pneumonia, for example.",
        },
        { type: "heading3", value: "Doctor’s input:" },
        {
          type: "paragraph",
          value:
            "You will want to know the doctor’s opinion on your prognosis (your chances of recovering and in what kind of shape you will be) and their recommendation before making the final decision.",
        },
        { type: "heading3", value: "Shared medical decision:" },
        {
          type: "paragraph",
          value:
            "This is where both you (or your substitute decision-maker) work with the doctor to make the decision that is right for you.",
        },
      ],
      eduContent: [
        { type: "delimiter" },
        {
          type: "heading2",
          value:
            "Questions that you may want to ask the doctor when seriously ill to be sure you are getting the medical care that is right for you:",
        },
        {
          items: [
            "Help me understand the big picture of my illness, what can I expect with my illness journey?",
            "How does this condition usually progress?",
            "On average, how long do people with my condition live for?",
            "With the treatments you are proposing, what are my chances of survival? If I survive, what will I be like, what kind of shape will I be in?",
            "Are you offering because you are supposed to or are you actually recommending?",
            "If we move forward with this course of action, will there be an opportunity to change or reverse direction?",
            "Are there any other options?",
          ],
          type: "list",
        },
      ],
      iconMode: "success",
      id: "3",
      image: "public-new/question-image-second.png",
      incorrectAnswer: true,
      onFalseResponse: [
        { type: "delimiter" },
        {
          type: "heading3",
          value:
            "Below are examples of questions that you may want to ask the doctor, when seriously ill, to be sure you are getting the medical care that is right for you:",
        },
        {
          items: [
            "Help me understand the big picture of my illness, what can I expect with my illness journey?",
            "How does this condition usually progress?",
            "On average, how long do people with my condition live for?",
            "With the treatments you are proposing, what are my chances of survival? If I survive, what will I be like, what kind of shape will I be in?",
            "Are you offering because you are supposed to or are you actually recommending?",
            "If we move forward with this course of action, will there be an opportunity to change or reverse direction?",
            "Are there any other options?",
          ],
          type: "list",
        },
      ],
      onTrueResponse: [
        { type: "delimiter" },
        {
          type: "heading3",
          value:
            "Below are examples of questions that you may want to ask the doctor, when seriously ill, to be sure you are getting the medical care that is right for you:",
        },
        {
          items: [
            "Help me understand the big picture of my illness, what can I expect with my illness journey?",
            "How does this condition usually progress?",
            "On average, how long do people with my condition live for?",
            "With the treatments you are proposing, what are my chances of survival? If I survive, what will I be like, what kind of shape will I be in?",
            "Are you offering because you are supposed to or are you actually recommending?",
            "If we move forward with this course of action, will there be an opportunity to change or reverse direction?",
            "Are there any other options?",
          ],
          type: "list",
        },
      ],
      questionTitle:
        "True or False: You are making treatment decisions today for when you are sick in the future?",
      title: "Making medical decisions with doctors",
      type: "true-false",
    },
    {
      answerResponseModal: [
        {
          type: "paragraph",
          value:
            "These statements made under conditions of certainty, as contained in many traditional advance care plans and legal planning documents, are not helpful. At the point where the doctor has to decide about ICU medicine or resuscitation, there are not sure if you are dying. Making medical decisions under conditions of uncertainty is a bit like predicting the weather. Some days, the forecast may say there’s a 50% chance of rain. You can’t be sure whether it will rain or not, but you still have to decide whether you take an umbrella or a raincoat with you just in case.",
        },
        {
          alt: "Making medical decisions when you don’t know how you will turn out",
          type: "image",
          value: "public-new/asip_decisions_nested.jpeg",
        },
        { type: "heading4", value: "It’s the same with your medical care." },
        {
          type: "paragraph",
          value:
            "At the point where doctors have to decide what treatments to use, they won’t know the outcome of your serious illness. Having a plan in place in case you become seriously ill and are unable to communicate will help. The important part of this planning is NOT about making a treatment decision, it is about being really clear on what’s important to you and what are your informed medical treatment preferences. Still not clear, see optional content below.",
        },
      ],
      conditionalContent: false,
      correctAnswer: false,
      description:
        "Sometimes when we ask people what medical treatments they would want during a serious illness, they say: “It depends, if I’m going to turn out okay, I’d want you to do everything to help me get better. But if I’m not going to turn out okay, then I want you to keep me comfortable.” Unfortunately, Doctors can’t predict for sure how things will turn out. We have to make medical decisions under conditions of uncertainty, when we don’t know exactly how things are going to turn out.",
      eduContent: [
        {
          columnsData: [
            {
              image: "public-new/couple-home.svg",
              tagTitle: "h2",
              text: "You go to the Emergency Department of the local hospital and the doctors are worried that your lungs will fail, and you will need to be put on a breathing machine (or a mechanical ventilator) and transferring you to the Intensive Care Unit (ICU) to keep you alive. At this point, you have a 50-50 chance of surviving the ICU care episode or not.",
              title:
                "Imagine a scenario where you (or an older loved one) develops a severe covid pneumonia. You are short of breath and feel very unwell.",
              type: "right",
            },
            {
              image: "public-new/couple-home.svg",
              tagTitle: "h3",
              text: "The doctors don’t know FOR SURE whether you are dying. You will most likely die if they don’t use machines and send you to the ICU. Realize that if you accept the machines and go to the ICU, after some period of time, you may be able to change the treatment plan. For example, if it becomes clearer and clearer that in fact, you are dying, then your appointed representative can advocate on your behalf to change the treatment plan and discontinue the use of machines, and create a more comfortable death experience.",
              title:
                "Can you see how saying, “If I am dying, I don’t want machines to be used” is not helpful?",
              type: "left",
            },
          ],
          type: "columns",
        },
      ],
      iconMode: "success",
      id: 4,
      image: "public-new/question-image-second.png",
      onFalseResponse: [
        {
          columnsData: [
            {
              image: "public-new/couple-home.svg",
              tagTitle: "h2",
              text: "You go to the Emergency Department of the local hospital and the doctors are worried that your lungs will fail, and you will need to be put on a breathing machine (or a mechanical ventilator) and transferring you to the Intensive Care Unit (ICU) to keep you alive. At this point, you have a 50-50 chance of surviving the ICU care episode or not.",
              title:
                "Imagine a scenario where you (or an older loved one) develops a severe covid pneumonia. You are short of breath and feel very unwell.",
              type: "right",
            },
            {
              image: "public-new/couple-home.svg",
              tagTitle: "h3",
              text: "The doctors don’t know FOR SURE whether you are dying. You will most likely die if they don’t use machines and send you to the ICU. Realize that if accept the machines and go to the ICU and after some period of time, lt becomes clearer and clearer that in fact, you are dying, that your substitute decision-maker (more on that word later) can advocate on your behalf to ‘change’ the treatment plan and the machines are removed, and a comfortable death follows.",
              title:
                "Can you see how saying, “If I am dying, I don’t want machines to be used” is not helpful?",
              type: "left",
            },
          ],
          type: "columns",
        },
      ],
      onTrueResponse: [
        {
          columnsData: [
            {
              image: "public-new/couple-home.svg",
              tagTitle: "h2",
              text: "You go to the Emergency Department of the local hospital and the doctors are worried that your lungs will fail, and you will need to be put on a breathing machine (or a mechanical ventilator) and transferring you to the Intensive Care Unit (ICU) to keep you alive. At this point, you have a 50-50 chance of surviving the ICU care episode or not.",
              title:
                "Imagine a scenario where you (or an older loved one) develops a severe covid pneumonia. You are short of breath and feel very unwell.",
              type: "right",
            },
            {
              image: "public-new/couple-home.svg",
              tagTitle: "h3",
              text: "The doctors don’t know FOR SURE whether you are dying. You will most likely die if they don’t use machines and send you to the ICU. Realize that if accept the machines and go to the ICU and after some period of time, lt becomes clearer and clearer that in fact, you are dying, that your substitute decision-maker (more on that word later) can advocate on your behalf to ‘change’ the treatment plan and the machines are removed, and a comfortable death follows.",
              title:
                "Can you see how saying, “If I am dying, I don’t want machines to be used” is not helpful?",
              type: "left",
            },
          ],
          type: "columns",
        },
      ],
      questionTitle:
        "This is an example of a statement that helps doctors figure out what treatment might be right for me: “When I am dying, I don’t want machines to be used.”",
      title:
        "Making medical decisions when you don’t know how you will turn out",
      type: "true-false",
    },
    {
      answersResponse: [
        {
          body: [
            { type: "delimiter" },
            {
              type: "heading2",
              value:
                "For more information on how doctors use your values to make treatment decisions see below:",
            },
            {
              type: "paragraph",
              value:
                "If quantity of life is more important than quality of life, doctors may use machines to try to keep you alive as long as possible, even if that reduces your quality of life.",
            },
            {
              type: "paragraph",
              value:
                "Focusing on life at all costs also puts you at greater risk of being alive but in a health state ‘worse than death.’",
            },
            {
              type: "paragraph",
              value:
                "We all value quality of life but if we communicate to doctors that we value quality of life over quantity of life, doctors may not recommend admission to the intensive care unit (ICU) but rather, focus on more conservative  treatments that maintain quality of life, even if it means that you might not live as long.",
            },
            {
              type: "paragraph",
              value:
                "Whether to use ICU machines in treating serious illness is another example of where values can compete with each other. We will explain later what we mean by ICU machines.",
            },
            {
              type: "paragraph",
              value:
                "If you are the kind of person that does not want ICU machines, the doctors may focus on other treatments that preserve the quality of your life and the quality of your death. If you are open to the use of machines, then doctors may admit you to ICU and seek to prolong your life at all costs.",
            },
          ],
          breakpoint: 3,
        },
        {
          body: [
            { type: "delimiter" },
            {
              type: "heading2",
              value:
                "For more information on how doctors use your values to make treatment decisions see below:",
            },
            {
              type: "paragraph",
              value:
                "If quantity of life is more important than quality of life, doctors may use machines to try to keep you alive as long as possible, even if that reduces your quality of life.",
            },
            {
              type: "pargraph",
              value:
                "Focusing on life at all costs also puts you at greater risk of being alive but in a health state ‘worse than death.’",
            },
            {
              type: "paragraph",
              value:
                "We all value quality of life but if we communicate to doctors that we value quality of life over quantity of life, doctors may not recommend admission to the intensive care unit (ICU) but rather, focus on more conservative  treatments that maintain quality of life, even if it means that you might not live as long.",
            },
            {
              type: "paragraph",
              value:
                "Whether to use ICU machines in treating serious illness is another example of where values can compete with each other. We will explain later what we mean by ICU machines.",
            },
            {
              type: "paragraph",
              value:
                "If you are the kind of person that does not want ICU machines, the doctors may focus on other treatments that preserve the quality of your life and the quality of your death. If you are open to the use of machines, then doctors may admit you to ICU and seek to prolong your life at all costs.",
            },
          ],
          breakpoint: 7,
        },
      ],
      description:
        "Values are personal feelings or beliefs that are most important to you when thinking about medical treatments that you might be offered when you are seriously ill. Your values are a big part of the medical decision-making process. It’s not what your family thinks is important. It’s not what your doctor thinks is important. Your values really express what you think, that is important.",
      details: [
        {
          type: "paragraph",
          value:
            "We want to help you learn to express your values in a way that will help you work with doctors to get the medical treatments that are right for you. Some values conflict or compete with each other. It is important to understand that, so again: sometimes, two values that you say are important may conflict or compete with each other. Watch this video to get a better understanding of what we mean by this.",
        },
        {
          embedUrl: "TbyV6Z_WQJQ",
          title: "Thinking about your values (What’s most important to you!)",
          type: "video",
        },
        {
          type: "paragraph",
          value:
            "Quality and quantity of life is a good example of competing or conflicting values as, living longer competes with enjoying a high quality of life. We all hope that we will live well with a high quality of life right up until the end, as illustrated by the ‘light blue’ image in the figure. However, this doesn’t happen very often. For most people, the longer you live, the more likely you are to experience a lower quality of life (illustrated by middle blue image).",
        },
        {
          type: "paragraph",
          value:
            "This may be a sudden change in health or a gradual change over time that can negatively affect your quality of life. Sometimes, those changes can mean you end up in a condition that you may consider worse than death, like for example, being in a permanent coma or totally dependent on others living in an institutional setting. Have you thought about what conditions are ‘worse than death’ from your perspective? Think about it. We will ask you to record your answer to this as we work through this section.",
        },
        {
          alt: "Thinking about your values (What’s most important to you!)",
          type: "image",
          value: "public-new/asip_trajectory_of_life.png",
        },
      ],
      eduContent: [
        { type: "delimiter" },
        {
          type: "heading2",
          value:
            "For more information on how doctors use your values to make treatment decisions see below:",
        },
        {
          type: "paragraph",
          value:
            "If quantity of life is more important than quality of life, doctors may use machines to try to keep you alive as long as possible, even if that reduces your quality of life. Focusing on life at all costs also puts you at greater risk of being alive but in a health state ‘worse than death.’",
        },
        {
          type: "paragraph",
          value:
            "We all value quality of life but if we communicate to doctors that we value quality of life over quantity of life, doctors may not recommend admission to the intensive care unit (ICU) but rather, focus on more conservative  treatments that maintain quality of life, even if it means that you might not live as long.",
        },
        {
          type: "paragraph",
          value:
            "Whether to use ICU machines in treating serious illness is another example of where values can compete with each other. We will explain later what we mean by ICU machines.",
        },
      ],
      equalLabel: "Equally important",
      id: 5,
      image: "public-new/question-image-first.png",
      max: 7,
      maxLabel:
        "I want medical treatments that focus on maintaining the quality of my life",
      min: 1,
      minLabel:
        "I would prefer medical treatments that focus on prolonging my life",
      questionTitle:
        "Today, given your current health, please tell us what is most important to you when considering the treatment options for serious illness. Do not think about what is important in the future when you are dying. We are asking what is important to you if you were to become seriously ill today. On a scale of 1-7, select the number to best describe how important you think the following is to you?",
      title: "Exploring your authentic values (What’s most important to you!)",
      type: "range",
    },
    {
      answersResponse: [
        {
          body: [
            { type: "delimiter" },
            {
              type: "heading2",
              value:
                "For more information on how doctors use your values to make treatment decisions see below:",
            },
            {
              type: "paragraph",
              value:
                "If quantity of life is more important than quality of life, doctors may use machines to try to keep you alive as long as possible, even if that reduces your quality of life.",
            },
            {
              type: "paragraph",
              value:
                "Focusing on life at all costs also puts you at greater risk of being alive but in a health state ‘worse than death.’",
            },
            {
              type: "paragraph",
              value:
                "We all value quality of life but if we communicate to doctors that we value quality of life over quantity of life, doctors may not recommend admission to the intensive care unit (ICU) but rather, focus on more conservative  treatments that maintain quality of life, even if it means that you might not live as long.",
            },
            {
              type: "paragraph",
              value:
                "Whether to use ICU machines in treating serious illness is another example of where values can compete with each other. We will explain later what we mean by ICU machines.",
            },
            {
              type: "paragraph",
              value:
                "If you are the kind of person that does not want ICU machines, the doctors may focus on other treatments that preserve the quality of your life and the quality of your death. If you are open to the use of machines, then doctors may admit you to ICU and seek to prolong your life at all costs.",
            },
          ],
          breakpoint: 3,
        },
        {
          body: [
            { type: "delimiter" },
            {
              type: "heading2",
              value:
                "For more information on how doctors use your values to make treatment decisions see below:",
            },
            {
              type: "paragraph",
              value:
                "If quantity of life is more important than quality of life, doctors may use machines to try to keep you alive as long as possible, even if that reduces your quality of life.",
            },
            {
              type: "pargraph",
              value:
                "Focusing on life at all costs also puts you at greater risk of being alive but in a health state ‘worse than death.’",
            },
            {
              type: "paragraph",
              value:
                "We all value quality of life but if we communicate to doctors that we value quality of life over quantity of life, doctors may not recommend admission to the intensive care unit (ICU) but rather, focus on more conservative  treatments that maintain quality of life, even if it means that you might not live as long.",
            },
            {
              type: "paragraph",
              value:
                "Whether to use ICU machines in treating serious illness is another example of where values can compete with each other. We will explain later what we mean by ICU machines.",
            },
            {
              type: "paragraph",
              value:
                "If you are the kind of person that does not want ICU machines, the doctors may focus on other treatments that preserve the quality of your life and the quality of your death. If you are open to the use of machines, then doctors may admit you to ICU and seek to prolong your life at all costs.",
            },
          ],
          breakpoint: 7,
        },
      ],
      conditionalContent: true,
      conditions: [
        { condition: [4], nextQuestion: "7a" },
        { condition: [0, 1, 2, 3], nextQuestion: "7b" },
      ],
      description:
        "This section will help learn more about the treatment options that are available to you when you are seriously ill.",
      details: [
        {
          type: "paragraph",
          value:
            "In general, there are 3 main types of care that you may receive when you are seriously ill.",
        },
        {
          items: ["Intensive Care", "Medical Care", "Comfort Care"],
          type: "list",
        },
        {
          items: [
            "public-new/asip_care_medical.jpeg",
            "public-new/asip_care_intensive.jpeg",
            "public-new/asip_care_comfort.jpeg",
          ],
          type: "listImages",
        },
      ],
      id: 6,
      image: "public-new/question-image-third.png",
      nextQuestionId: 7,
      questionTitle:
        "To start, let’s ask you some questions to see how much you know about these different types of care available to treat serious",
      questions: [
        {
          id: "6a",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "If you are very ill, there is a greater chance of survival in the ICU than with other types of medical care.",
            title: "Your answer is correct!",
          },
          options: [
            { correct: true, text: "ICU Care" },
            { correct: false, text: "Medical Care" },
            { correct: false, text: "Comfort Care" },
            { correct: false, text: "None of the above" },
          ],
          questionTitle:
            "Which one of the following types of care is most likely to result in the best chance of surviving?",
          type: "test",
        },
        {
          id: "6b",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "Patients with serious illness who receive comfort care are much more likely to experience a higher quality of life in those final stages of life and experience a natural, dignity-preserving death, without the use of machines.",
            title: "Your answer is correct!",
          },
          options: [
            { correct: false, text: "ICU Care" },
            { correct: false, text: "Medical Care" },
            { correct: true, text: "Comfort Care" },
            { correct: false, text: "None of the above" },
          ],
          questionTitle:
            "Which one of the following types of care is most likely to result in a natural, dignity-preserving death?",
          type: "test",
        },
        {
          id: "6c",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "Most patients with serious illness who receive comfort care do not survive their illness even if their illness was curable because curative treatments are often withheld. This is the biggest downside or drawback of preferring comfort care- that you could die prematurely because curative treatments are withheld when you have a curable medical problem.",
            title: "Your answer is correct!",
          },
          options: [
            {
              correct: false,
              text: "Having bruised or broken ribs from pressing on the chest.",
            },
            {
              correct: false,
              text: "Severe brain damage from lack of oxygen.",
            },
            { correct: true, text: "It is frightening to watch." },
            { correct: false, text: "None of the above" },
          ],
          questionTitle:
            "Which one of the following types of care is most likely to result in a certain death even if you present with a curable or fixable illness or injury?",
          type: "test",
        },
        {
          id: "6d",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "In the ICU you may be in more pain and discomfort because of the machines, and if you are in the ICU for a long time, you might end up very weak and not as mentally aware. You may only be delaying death and your death may not end up being very natural or dignified.",
            title: "Your answer is correct!",
          },
          options: [
            {
              correct: false,
              text: "Surviving with a lower quality of life or functional status",
            },
            {
              correct: false,
              text: "Experiencing increased chances of pain and discomfort",
            },
            {
              correct: false,
              text: "Prolonging the dying experience which adds to patient and family suffering",
            },
            { correct: true, text: "All of the above" },
          ],
          questionTitle:
            "Which of the following are considered risks or side effects of ICU care?",
          type: "test",
        },
      ],
      title: "Different Types of Care",
      type: "multiple",
    },
    {
      currentVariant: "7b",
      id: 7,
      noValidation: true,
      offDelimiter: true,
      type: "conditional",
      variants: [
        {
          answersResponse: [
            { type: "delimiter" },
            {
              type: "paragraph",
              value:
                " Feel free to move to the next section or, if you are interested in more details, check out our learning center information on the different types of medical care available to treat serious illness .”",
            },
            {
              items: [
                {
                  content: "link to learning center",
                  linkUrl: "#",
                  title: "ICU Care",
                },
                {
                  content: "link to learning center",
                  linkUrl: "#",
                  title: "Medical Care",
                },
                {
                  content: "link to learning center",
                  linkUrl: "#",
                  title: "Comfort Care",
                },
              ],
              type: "listLinks",
            },
          ],
          description:
            "Congratulations on doing so well. You seem to understand the key differences between ICU, medical and comfort care. Hopefully, this information will be helpful to you when making your final preference for which treatment might be ‘right’ for you.",
          iconMode: "success",
          id: "7a",
          offDelimiter: true,
          questionTitle: "Congratulations on doing so well!",
          type: "info",
        },
        {
          answersResponse: [
            { type: "delimiter" },
            {
              type: "paragraph",
              value:
                "Based on your score, consider reviewing our information in the learning center on the different types of medical care available to treat serious illness.",
            },
            { type: "heading3", value: "Learning Center Links" },
            {
              items: [
                {
                  content: "link to learning center",
                  linkUrl: "#",
                  title: "ICU Care",
                },
                {
                  content: "link to learning center",
                  linkUrl: "#",
                  title: "Medical Care",
                },
                {
                  content: "link to learning center",
                  linkUrl: "#",
                  title: "Comfort Care",
                },
              ],
              type: "listLinks",
            },
          ],
          description:
            "The purpose of these questions was to assess how much you currently understand about the different types of treatments available to you when you are seriously ill. Later in this workbook, we will ask you to determine your final medical preference, the treatment option that might be ‘right’ for you. How sure are you that you understand the differences between these different treatment options?",
          iconMode: "warning",
          id: "7b",
          offDelimiter: true,
          questionTitle: "Keep going!",
          type: "info",
        },
      ],
    },
    {
      answersResponse: [
        {
          body: [
            { type: "delimiter" },
            {
              type: "heading2",
              value:
                "For more information on how doctors use your values to make treatment decisions see below:",
            },
            {
              type: "paragraph",
              value:
                "If quantity of life is more important than quality of life, doctors may use machines to try to keep you alive as long as possible, even if that reduces your quality of life.",
            },
            {
              type: "paragraph",
              value:
                "Focusing on life at all costs also puts you at greater risk of being alive but in a health state ‘worse than death.’",
            },
            {
              type: "paragraph",
              value:
                "We all value quality of life but if we communicate to doctors that we value quality of life over quantity of life, doctors may not recommend admission to the intensive care unit (ICU) but rather, focus on more conservative  treatments that maintain quality of life, even if it means that you might not live as long.",
            },
            {
              type: "paragraph",
              value:
                "Whether to use ICU machines in treating serious illness is another example of where values can compete with each other. We will explain later what we mean by ICU machines.",
            },
            {
              type: "paragraph",
              value:
                "If you are the kind of person that does not want ICU machines, the doctors may focus on other treatments that preserve the quality of your life and the quality of your death. If you are open to the use of machines, then doctors may admit you to ICU and seek to prolong your life at all costs.",
            },
          ],
          breakpoint: 3,
        },
        {
          body: [
            { type: "delimiter" },
            {
              type: "heading2",
              value:
                "For more information on how doctors use your values to make treatment decisions see below:",
            },
            {
              type: "paragraph",
              value:
                "If quantity of life is more important than quality of life, doctors may use machines to try to keep you alive as long as possible, even if that reduces your quality of life.",
            },
            {
              type: "pargraph",
              value:
                "Focusing on life at all costs also puts you at greater risk of being alive but in a health state ‘worse than death.’",
            },
            {
              type: "paragraph",
              value:
                "We all value quality of life but if we communicate to doctors that we value quality of life over quantity of life, doctors may not recommend admission to the intensive care unit (ICU) but rather, focus on more conservative  treatments that maintain quality of life, even if it means that you might not live as long.",
            },
            {
              type: "paragraph",
              value:
                "Whether to use ICU machines in treating serious illness is another example of where values can compete with each other. We will explain later what we mean by ICU machines.",
            },
            {
              type: "paragraph",
              value:
                "If you are the kind of person that does not want ICU machines, the doctors may focus on other treatments that preserve the quality of your life and the quality of your death. If you are open to the use of machines, then doctors may admit you to ICU and seek to prolong your life at all costs.",
            },
          ],
          breakpoint: 7,
        },
      ],
      conditions: [
        { condition: [5], nextQuestion: "9a" },
        { condition: [0, 1, 2, 3, 4], nextQuestion: "9b" },
      ],
      description:
        "Cardiopulmonary resuscitation or CPR is usually a part of intensive care but can be provided in other parts of the hospital as well. Do you know what happens when a person receives CPR? Most people know that CPR can help people in an emergency when their heart stops, but they get a lot of wrong information from TV about how CPR works. CPR doesn’t work for everyone – and if you have an underlying serious illness, having CPR might mean you end up getting other medical treatments that you don’t want.",
      details: [
        {
          type: "paragraph",
          value:
            "CPR is the default treatment for patients in hospital who have not clarified that they don’t want CPR.",
        },
        {
          type: "paragraph",
          value:
            "  It will be important for you to become informed and to develop your personal preference for or against the use of CPR if you were to need it. We have a 7 min video decision aid on CPR for you to watch.",
        },
      ],
      id: 8,
      image: "public-new/question-image-third.png",
      nextQuestionId: 9,
      questionTitle:
        "However, first, let’s assess how much you know about CPR. Please take your time answering these questions:",
      questions: [
        {
          id: "8a",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "If you get CPR and your heart re-starts, you usually will need a machine to help you breathe, as well as medicines and fluids while you recover in the Intensive Care Unit (ICU).",
            title: "Your answer is correct!",
          },
          options: [
            {
              correct: false,
              text: "Is able to resume their usual activities",
            },
            {
              correct: false,
              text: "Usually needs to rest in bed for a few days",
            },
            {
              correct: true,
              text: "Usually needs a machine to help with breathing, medicines, and fluids while trying to recover in ICU (Intensive Care Unit)",
            },
            { correct: false, text: "Don’t know" },
          ],
          questionTitle:
            "If CPR is successful and the heart restarts, the person:",
          type: "test",
        },
        {
          id: "8b",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "The most serious possible harm from your heart stopping and you needing CPR is that you may end up with severe brain damage from the lack of oxygen from the time your heart stopped and was re-started.",
            title: "Your answer is correct!",
          },
          options: [
            {
              correct: false,
              text: "Having bruised or broken ribs from pressing on the chest",
            },
            {
              correct: true,
              text: "Severe brain damage from lack of oxygen",
            },
            { correct: false, text: "It is frightening to watch" },
            { correct: false, text: "Don’t know" },
          ],
          questionTitle:
            "The most serious possible harm from the heart stopping and needing to have CPR is:",
          type: "test",
        },
        {
          id: "8c",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "Very few people (less than 18 out of 100) survive and recover well enough to leave the hospital after they’ve had a cardiac arrest and CPR.",
            title: "Your answer is correct!",
          },
          options: [
            { correct: false, text: "Everyone survives (100 out of 100)" },
            {
              correct: false,
              text: "About half of the people (50 out of 100)",
            },
            {
              correct: true,
              text: "Very few people (less than 18 out of 100)",
            },
            { correct: false, text: "Don’t know" },
          ],
          questionTitle:
            "If 100 people who have a cardiac arrest where their hearts stop and they undergo CPR, how many will survive and recover well enough to leave the hospital?",
          type: "test",
        },
        {
          id: "8d",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "For people who have a chronic heart condition, such as heart failure, kidney failure or lung disease, fewer than 10 out of 100 will survive CPR and recover well enough to leave the hospital.",
            title: "Your answer is correct!",
          },
          options: [
            { correct: false, text: "Everyone survives (100 out of 100)" },
            {
              correct: false,
              text: "About half of the people (50 out of 100)",
            },
            {
              correct: true,
              text: "Very few people (fewer than 10 out of 100)",
            },
            { correct: false, text: "Don’t know" },
          ],
          questionTitle:
            "If 100 people who have a chronic condition (heart failure, kidney failure, chronic lung disease) and their hearts stop, how many will survive CPR and recover well enough to leave the hospital?",
          type: "test",
        },
        {
          id: "8e",
          offDelimiter: true,
          onCorrectAnswer: {
            text: "Of all people who survive CPR, a few will have serious problems with their ability to think.",
            title: "Your answer is correct!",
          },
          options: [
            { correct: false, text: "All survivors" },
            { correct: false, text: "More than half of survivors" },
            { correct: true, text: "A few survivors" },
            { correct: false, text: "Don’t know" },
          ],
          questionTitle:
            "Of all the people who survive CPR, how many will have serious problems with their ability to think?",
          type: "test",
        },
      ],
      title:
        "Exploring Whether Cardiopulmonary Resuscitation (CPR) Is Right for You?",
      type: "multiple",
      video: {
        embedUrl: "TbyV6Z_WQJQ",
        title:
          "Exploring Whether Cardiopulmonary Resuscitation (CPR) Is Right for You?",
      },
    },
    {
      currentVariant: "9b",
      id: 9,
      noValidation: true,
      offDelimiter: true,
      type: "conditional",
      variants: [
        {
          answersResponse: [
            { type: "delimiter" },
            {
              embedUrl: "v65Qoi8lCac",
              title:
                "Thinking about your values (What’s most important to you!)",
              type: "video",
            },
          ],
          description:
            "“Congratulations on doing so well. You seemed to understand the important facts about CPR. Hopefully, this information will be helpful to you when deciding whether CPR might be ‘right’ for you. If you are interested in more details, check out our CPR video decision aid.",
          iconMode: "success",
          id: "9a",
          offDelimiter: true,
          questionTitle: "Congratulations on doing so well",
          type: "info",
        },
        {
          answersResponse: [
            { type: "delimiter" },
            {
              embedUrl: "v65Qoi8lCac",
              title:
                "Thinking about your values (What’s most important to you!)",
              type: "video",
            },
          ],
          description:
            "“The purpose of these questions was to assess how you knew about the risks or benefits of CPR and whether it might be ‘right’ for you. Later in this workbook, we will ask you if you think CPR might be right for you. How confident are you that you know enough about CPR to make a final preference? Based on your answers to the above questions, you could consider watching the CPR video before proceeding to the next section.",
          iconMode: "warning",
          id: "9b",
          offDelimiter: true,
          questionTitle: "Keep going!",
          type: "info",
        },
      ],
    },
  ],
};

export const DEFAULT_SUMMARY_CONTENT: { data: any } = { data: {} };
